<template>

  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :blank-menus-data="blankMenusData"
      :childs-options-menus="menusOptions"
      :grupos-options="gruposOptions"
      @refetch-data="refetchData"
      @input="showAddEditMenus"
    />

    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="primary"
                @click="addMenu"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Grupo
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="fetchMenus"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        eempty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Titulo -->
        <template #cell(title)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.title)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.title }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Ordem -->
        <template #cell(order)="data">
          <b-media vertical-align="center">
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.order }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px"
          >
            <feather-icon
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click="editarMenu(data.item.id_menu)"
            />
            <feather-icon
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-modal.modal-confirme-delete-grupo
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idMenu = data.item.id_menu"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalMenusFucionalidades"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-grupo"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o grupo?"
      @ok="deletedMenu"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import UsersListFilters from './menusListFilters.vue'
import gruposStoreModule from '../menusStoreModule'
import UserListAddNew from './MenusListAddNew.vue'
import useFucionalidadesMenusList from './useFucionalidadesMenusList'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  setup() {
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'app-adm-menus'
    const blankMenusData = ref({
      id_menu: null,
      title: '',
      order: '',
      icon: '',
      route: '',
      ativo: 1,
      id_parent: null,
    })
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, gruposStoreModule)
    const menusOptions = ref([])
    const gruposOptions = ref([])
    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchMenus`)
        .then(resp => {
          menusOptions.value = resp.data.menus
        })
      store.dispatch('app-adm-grupousuario/fetchUGrupos')
        .then(resp => {
          gruposOptions.value = resp.data.grupos
        })
    })

    const updatedStatusFilter = () => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchMenus`)
        .then(resp => {
          menusOptions.value = resp.data.menus
        })
      store.dispatch('app-adm-grupousuario/fetchUGrupos')
        .then(resp => {
          gruposOptions.value = resp.data.grupos
        })
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditMenus = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addMenu = async () => {
      blankMenusData.value = {
        id_menu: null,
        title: '',
        order: '',
        icon: '',
        route: '',
        ativo: 1,
        id_parent: null,
      }
      isAddNewUserSidebarActive.value = true
    }

    const editarMenu = async idMenuEditar => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchMenu`, { id: idMenuEditar })
        .then(data => {
          blankMenusData.value = data.data
          isAddNewUserSidebarActive.value = true
        })
    }

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchMenus,
      tableColumns,
      perPage,
      currentPage,
      totalMenusFucionalidades,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useFucionalidadesMenusList()
    const idMenu = ref(null)
    const deletedMenu = async () => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/deleteMenu`, { id: idMenu.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idMenu.value = null
          refetchData()
        })
      refetchData()
    }
    return {
      gruposOptions,
      idMenu,
      addMenu,
      blankMenusData,
      editarMenu,
      showAddEditMenus,
      menusOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchMenus,
      tableColumns,
      perPage,
      currentPage,
      totalMenusFucionalidades,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deletedMenu,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
